export const TASTE_PROFILE_GA_EVENT = {
  event: 'genericEvent',
  eventCategory: 'Smaakprofielen - Wijn'
}

export const TASTE_PROFILE_GA_FILTER_EVENT = {
  event: 'genericEvent',
  eventCategory: 'Smaakprofielen - Jouw wijnen'
}

export const TASTE_PROFILE_WINE_LIST_URL = `${process.env.WEBSHOP_SMAAKPROFIELEN_PATH}/jouw-wijnen/`
export const TASTE_PROFILE_CHOICE_IMAGE_INDEX_MAP = ['a', 'b']

export const GTM_CLICK_TRACKING_PROP_NAME = 'data-tracking-click'
export const GTM_IMPRESSION_TRACKING_PROP_NAME = 'data-tracking-impression'
